import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const StNavigationItem = styled(NavLink)`
  display: flex;
  flex-direction: column;
  user-select: none;
  text-align: center;
  position: relative;
  width: 100%;
  z-index: 1;

  ${({ theme }) => {
    return `
      padding: ${theme.UI.SpacingPx.Space4} ${theme.UI.SpacingPx.Space4} max(var(--safe-area-inset-bottom), ${theme.UI.SpacingPx.Space4});
      margin: ${theme.UI.SpacingPx.Space1} 0;
      color: ${theme.Components.Navigation.Text};

      transition: color 175ms ease-in-out;

      &:hover {
        color: ${theme.Components.Navigation.ActiveText};
      }

      &.active {
        pointer-events: none;
        color: ${theme.Components.Navigation.ActiveText};

        >  * {
          z-index: 1;
        }

        span {
          font-weight: 700;
        }

        &::after {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          z-index: 0;
          width: 100%;
          height: 100%;
          background-color: ${theme.Colors.Neutrals.Lightest};
          border-radius: ${theme.UI.BorderRadius.Small}px;
          animation: zoomIn;
          animation-duration: 150ms;
        }
      }
    `
  }}

  svg {
    margin-bottom: 10px;
  }

  @media ${breakpoints.s} {
    text-align: left;
    flex-direction: row;
    align-items: center;

    svg {
      margin-right: 10px;
      margin-bottom: 0;
    }
  }
`

export { StNavigationItem }
